import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

class MainFooter extends React.Component {

	render() {
		return (
			<footer className="main-footer">
				<strong>Copyright © {moment().format('YYYY')} <a href="https://www.pagony.hu" target="_blank">Pozsonyi Pagony Kft</a>.</strong>
				{ this.props.children}
			</footer>
		);
	}
}
export default connect((state) =>{
	return {
		config: state.app.template
	};
})(MainFooter);